import { render, staticRenderFns } from "./ReportedMaintenance.vue?vue&type=template&id=5d010b99"
import script from "./ReportedMaintenance.vue?vue&type=script&lang=ts"
export * from "./ReportedMaintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports